import { createTheme } from "@mui/material/styles";

const Table_theme = createTheme({
  components: {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          width: "100%",
          overflowX: "auto",
          borderRadius: 8,
          border: "1px solid #e0e0e0",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",

          // Thin scrollbar — hidden until hover
          "&::-webkit-scrollbar": {
            width: 6,
            height: 6,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "transparent",
            borderRadius: 3,
          },
          "&:hover::-webkit-scrollbar-thumb": {
            backgroundColor: "#aaa", // subtle gray thumb on hover
          },

          // Firefox support
          scrollbarWidth: "thin",
          scrollbarColor: "transparent transparent",

          "&:hover": {
            scrollbarColor: "#aaa transparent",
          },
        },
      },
    },
    MuiTable: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          minWidth: 650,
          borderCollapse: "separate",
          borderSpacing: 0,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "white",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          transition: "background 0.2s ease",
          "&:hover": {
            backgroundColor: "white",
          },
          "& .MuiTableCell-root": {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "13px",
          color: "#444",
          borderBottom: "1px solid #e0e0e0",
          whiteSpace: "nowrap",
          paddingTop: 2,
          paddingBottom: 2,
        },
        head: {
          fontWeight: 600,
          fontSize: "13px",
          color: "#222",
          backgroundColor: "white",
          borderBottom: "1px solid #dcdcdc",
          textTransform: "capitalize",
          paddingTop: 6,
          paddingBottom: 6,
        },
      },
    },
  },
});

export default Table_theme;